export default {
  link: {
    base: {},
    variants: {
      focus: {
        borderColor: 'orange'
      },
      current: {
        backgroundColor: 'primary',
        color: 'grey-0',
        border: 'none'
      }
    }
  },
  linkText: {
    variants: {
      current: {
        color: 'grey-0'
      }
    }
  }
};